import { useEffect, useState } from "react";
import { ReqDetail } from "../../../api/LeaderPortalApi";
import { notify } from "../../utils";
import { RightArrowGrey } from "../../icons/RightArrow";
import { HeaderOfDetail } from "../../utils/HeaderOfLeaderPortal";
import { UserHeaderReq } from "../../icons/HeaderIcons";
import { Toaster } from "react-hot-toast";
import { ChangeTransactionStatusPaid, EkycDonePopUp, EkycDoneReset } from "./EkycDonePopUp";
import forge from  'node-forge';
import { encryptAES } from "../../utils/encryption";
import { setUniqueData,setTimeStamp } from "../../redux/actions/FirstInfoAction";
import { useDispatch,useSelector } from "react-redux";
export default function DetailPersonalityRequest({ setDetailId, detailId }) {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false)
    const [data, setData] = useState("")
    const [encryptedData, setEncryptedData] = useState(useSelector(state => state.FirstInfo.uniqueData));
    const [stampTime, setStampTime] = useState(useSelector(state => state.FirstInfo.timeStamp));
    const [transactionId, setTransactionId] = useState("")
    const [transactionStatus, setTransactionStatus] = useState("")
    const [openModal, setOpenModal] = useState(false)
    const [openModalStatus, setOpenModalStatus] = useState(false)
    const [openModalReset, setOpenModalReset] = useState(false)
    const [loadingPage, setLoadingPage] = useState(false)

    const downloadCsrAsTxt = (nationalId, certificate) => {
        let downloadName = '';
        let newTimeStamp = '';
        let newEncryptedData = '';
        if (encryptedData != '' && encryptedData != null && encryptedData != undefined && stampTime != '' && stampTime != undefined && stampTime != null) {
            downloadName = nationalId + `_${stampTime}` + `_${encryptedData}` + '_certificate.crt';
        } else {
            newTimeStamp = Date.now();
            newEncryptedData = encryptAES(nationalId, newTimeStamp);
            setEncryptedData(newEncryptedData);
            setStampTime(newTimeStamp);
            dispatch(setUniqueData({uniqueData:newEncryptedData}));

            dispatch(setTimeStamp({timeStamp:newTimeStamp}))
            downloadName = nationalId + `_${newTimeStamp}` + `_${newEncryptedData}` + '_certificate.crt';
        }
        
  

        const txtContent = new Blob([certificate ? certificate : ''], { type: 'text/plain' });
        const a = document.createElement('a');
        a.href = URL.createObjectURL(txtContent);
        a.download = downloadName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(a.href);
    };

    useEffect(() => {
        setIsLoading(true)
        ReqDetail(detailId).then(response => {
            setIsLoading(false)
            setData(response?.data)
            setTransactionId(response?.data?.transactionId)
            setTransactionStatus(response?.data?.transactionStatus);
        }).catch(error => {
            setIsLoading(false)
            notify(error?.response?.data?.message)
        })
    }, [loadingPage])

    return (
        <>
            <Toaster />
            <div className={`d-flex pointer`} style={{ width: "10px" }} onClick={() => setDetailId("")}>
                <div><RightArrowGrey /></div>
                <p className={`d-flex align-items-center m-0`}
                    style={{ fontSize: "0.8rem", color: "#7a7a7a", paddingRight: "0.1rem" }}
                >بازگشت</p>
            </div>

            <HeaderOfDetail
                title={'مشاهده درخواست مهر سازمانی'}
                text={
                    <div>درخواست گواهی مهر سازمانی با کد ملی
                        <span style={{ fontWeight: "700" }}> {data?.nationalId} </span>
                        و شناسه ملی
                        <span style={{ fontWeight: "700" }}> {data?.companyInfo?.companyNationalId} </span>
                        قابل مشاهده می‌باشد </div>
                }
                traceId={data?.traceId}
                status={data?.transactionStatus}
                cert={data?.certificate}
                certType={"Personality"}
            />

            <div className={`request-body-div px-4 pt-0 pb-3 mt-4`} style={{ minHeight: "60vh" }}>
                <div className={`d-flex justify-content-center`}><UserHeaderReq /></div>

                <div className='row-detail'>
                    <span className={`row-detail-span`}>کد ملی</span>
                    <span>{data?.nationalId}</span>
                </div>

                <div className='row-detail'>
                    <span className={`row-detail-span`}>نام</span>
                    <span>{data?.firstName}</span>
                </div>

                <div className='row-detail'>
                    <span className={`row-detail-span`}>نام خانوادگی</span>
                    <span>{data?.lastName}</span>
                </div>

                <div className='row-detail'>
                    <span className={`row-detail-span`}>نام به انگلیسی</span>
                    <span>{data?.latinFirstName}</span>
                </div>

                <div className='row-detail'>
                    <span className={`row-detail-span`}>نام خانوادگی به انگلیسی</span>
                    <span>{data?.latinLastName}</span>
                </div>

                <div className='row-detail'>
                    <span className={`row-detail-span`}>شماره تلفن همراه</span>
                    <span>{data?.phoneNumber}</span>
                </div>

                <div className='row-detail'>
                    <span className={`row-detail-span`}>استان محل اقامت</span>
                    <span>{data?.province}</span>
                </div>

                <div className='row-detail'>
                    <span className={`row-detail-span`}>شهر محل اقامت</span>
                    <span>{data?.city}</span>
                </div>

                <div className='row-detail'>
                    <span className={`row-detail-span`}>آدرس محل اقامت</span>
                    <span>{data?.address}</span>
                </div>

                <div className='row-detail' style={{ border: "none" }}>
                    <span className={`row-detail-span`}>کد پستی محل اقامت</span>
                    <span>{data?.postalCode}</span>
                </div>

            </div>

            {data?.transactionStatus === "USER_INFORMATION_COMPLETED" &&

                <>
                    <div className='row justify-content-center my-5 mb-2'>
                        <div className='col-4 me-2'>
                            <button
                                onClick={() => setOpenModal(true)}
                                className='btn w-100 text-form-button'
                                style={{ "background": "#044448" }}
                            >
                                تایید احراز هویت تصویری
                            </button>
                        </div>
                    </div>

                    {
                        data?.ekycCounter >= 10 &&
                        <div className='row justify-content-center my-3 '>
                            <div className='col-4 me-2'>
                                <button
                                    onClick={() => setOpenModalReset(true)}
                                    className='btn w-100 text-form-button'
                                    style={{ "background": "#044448" }}
                                >
                                    تلاش مجدد برای احراز هویت
                                </button>
                            </div>
                        </div>
                    }
                </>
            }


            {transactionStatus === "SENT_CERT_ISSUED" &&

                <div className='row justify-content-center my-5 '>
                    <div className='col-4 me-2'>
                        <button
                            onClick={() => setOpenModalStatus(true)}
                            className='btn w-100 text-form-button'
                            style={{ "background": "#044448" }}
                        >
                            بازگشت به مرحله تکمیل اطلاعات
                        </button>
                    </div>
                </div>
            }

            <div className='row justify-content-center my-5 '>
                {data?.certificate &&
                    <div className='col-4 me-2'>
                        <button
                            onClick={() => downloadCsrAsTxt(data?.nationalId, data?.certificate)}
                            className='btn w-100 text-form-button'
                            style={{ "background": "#044448" }}
                        >
                            دانلود گواهی
                        </button>
                    </div>
                }
            </div>

            <EkycDonePopUp
                open={openModal}
                setOpen={setOpenModal}
                id={detailId}
                setLoadingPage={setLoadingPage}
            />

            <EkycDoneReset
                open={openModalReset}
                setOpen={setOpenModalReset}
                id={detailId}
                setLoadingPage={setLoadingPage}
            />

            <ChangeTransactionStatusPaid
                open={openModalStatus}
                setOpen={setOpenModalStatus}
                id={detailId}
                setLoadingPage={setLoadingPage}
            />
        </>
    )
}